import { HashMap } from "shared/model/HashMap";
import { ProcessTemplate, ProcessTemplateImport } from "./ProcessTemplate";
import { ProcessTemplateAppReducerAction } from "processTemplates/reducers/AppReducer";
import { MissingTask } from "./MissingTask";

export interface ProcessTemplateAppState {
    loading: boolean;
    processTemplates?: ProcessTemplate[];
    processTemplatesCount?: number;
    availableTags: string[];
    importModalOpen: boolean;
    confirmProcessUpdatesForTemplateImport?: ProcessTemplateImport;
    editedTemplate?: ProcessTemplate;
    templateForCreate?: ProcessTemplate;
    viewChangeLogForTemplateId?: number;
    usedInModalState?: UsedInModalState;
    switchVersionForTemplateId?: number;
    deletedTemplateIds?: number[];
    taggedTemplateIds?: number[];
    selectedTemplateIds: number[];
    userPermissions: HashMap<boolean>;
    missingTasks: MissingTask[];
}

export interface ProcessTemplateAppReducerState {
    state: ProcessTemplateAppState;
    dispatch: (payload: ProcessTemplateAppReducerAction) => void;
}

export interface UsedInModalState {
    processTemplate: ProcessTemplate;
    mode: ProcessesUsingTemplateType;
}

export enum ProcessesUsingTemplateType {
    Current,
    Older,
    Deviated,
}